import { callApi } from '../../../api/call';

const getSMSSettings = async (companyId) => {
  const response = await callApi(`/api/companies/${encodeURIComponent(companyId)}/sms-settings/get`, {
    companyId,
  });
  return response.data;
};

const updateSMSSettings = async (companyId, settings) => {
  const response = await callApi(`/api/companies/${encodeURIComponent(companyId)}/sms-settings`, {
    settings,
  });
  return response.data;
};

const sendTestSMS = async (companyId, templateType, phoneNumber, customMessage) => {
  const response = await callApi(`/api/companies/${encodeURIComponent(companyId)}/sms-settings/test`, {
    templateType,
    phoneNumber,
    ...(customMessage ? { customMessage } : {}),
  });
  return response.data;
};

export const smsSettingsService = {
  getSMSSettings,
  updateSMSSettings,
  sendTestSMS,
};
